module.exports = __webpack_public_path__ + "img/active-21.b4751075.svg";